const settingPageConstants = {
  vessel: {
    source: [
      {
        selector: "MMSI",
        owner: "CAPTN",
        type: "AIS",
      },
      {
        selector: "TrackID",
        owner: "SAILTRACKS",
        type: "AIS",
      },
    ],
  },
};

export type IDateModelTypes =
  | "AIS"
  | "MaritimeTargets"
  | "PlannedPath"
  | "RadarTarget"
  | "FusionMaritimeTarget";

export type IDataTypeSpec = {
  [key in IDateModelTypes]: {
    type: string;
    dataSources: Record<string, string | string[]>[];
    hasMultipleLayers: boolean;
    showDefaultLayer: boolean;
    showTempLayer?: boolean;
    tempLayerSuffix?: string;
  };
};

type DataModels = {
  dataModel: IDataTypeSpec;
  dataSourceSelector: {
    MMSI: {
      label: string;
      value: {
        type: string;
        owner: string;
      };
    };
    TrackID: {
      label: string;
      value: {
        type: string;
        owner: string;
      };
    };
  };
};

type MapUtils = {
  globale: {
    showPermanentTooltip: boolean;
  };
  tileLayerOptions: {
    OSM: string;
    WmsChart: string;
    OpenSeaMap: string;
  };
  polyline: {
    overlayPaneTypes: {
      trackingLine: string;
      predictionLine: string;
      plannedPathLine: string;
    };
  };
  marker: {
    overlayPaneTypes: {
      title: string;
      selectedMarker: string;
    };
  };
};

export type LeafletInstanceConfigConstants = MapUtils & DataModels;

export const config: LeafletInstanceConfigConstants = {
  dataModel: {
    AIS: {
      type: "AIS",
      dataSources: [
        { AIS: ["AI:VDM", "ST:PREDICT"] },
        { GLL: ["IN:GLL", "ST:PREDICT"] },
        { Live: ["ST:LIVE", "ST:PREDICT", "ST:REPLAY"] },
      ],
      hasMultipleLayers: false,
      showDefaultLayer: false,
      showTempLayer: false,
      tempLayerSuffix: "_temp",
    },
    MaritimeTargets: {
      type: "MaritimeTargets",
      dataSources: [
        { IN_TTD: "IN:TTD" },
        { IN_TLLAIS: "IN:TLLAIS" },
        { SF_CAM: "SF:CAM" },
      ],
      hasMultipleLayers: true,
      showDefaultLayer: false,
    },
    PlannedPath: {
      type: "PlannedPath",
      dataSources: [],
      hasMultipleLayers: false,
      showDefaultLayer: false,
    },
    RadarTarget: {
      type: "RadarTarget",
      dataSources: [],
      hasMultipleLayers: false,
      showDefaultLayer: false,
    },
    FusionMaritimeTarget: {
      type: "FusionMaritimeTarget",
      dataSources: [],
      hasMultipleLayers: false,
      showDefaultLayer: false,
    },
  },
  // Recognition of which data types are involved based on certain indicators.
  // These are currently supported by the map plugin.
  // Currently only data of the NGSI type AIS is supported
  dataSourceSelector: {
    MMSI: {
      label: settingPageConstants.vessel.source[0].selector,
      value: {
        type: settingPageConstants.vessel.source[0].type,
        owner: settingPageConstants.vessel.source[0].owner,
      },
    },
    TrackID: {
      label: settingPageConstants.vessel.source[1].selector,
      value: {
        type: settingPageConstants.vessel.source[1].type,
        owner: settingPageConstants.vessel.source[1].owner,
      },
    },
  },
  globale: {
    showPermanentTooltip: true,
  },
  tileLayerOptions: {
    OSM: "OSM",
    WmsChart: "WMS-Chart",
    OpenSeaMap: "OpenSeaMap",
  },
  polyline: {
    overlayPaneTypes: {
      trackingLine: "trackingLineOverlayPane",
      predictionLine: "predictionLineOverlayPane",
      plannedPathLine: "plannedPathOverlayPane",
    },
  },
  marker: {
    overlayPaneTypes: {
      title: "markerTitlePane",
      selectedMarker: "selectedMarkerPane",
    },
  },
};
